import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MDBModalRef } from '../mdb-compat';

@Component({
  selector: 'app-modal-browser-warning',
  standalone: false,
  templateUrl: './modal-browser-warning.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./modal-browser-warning.component.scss']
})
export class ModalBrowserWarningComponent implements OnInit {

  constructor(public modalRef: MDBModalRef) { }

  ngOnInit(): void {
  }

}
